import { isReportShownLinkedStudy } from "@shared/study";

import { StudyContextData, SubmissionContextData } from "@/context/AppContext";
import { useStudyView } from "@/context/ViewContexts";

import { RoundButton } from "@shared/components/Button";

import { T } from "@/components/i18n";
import { Heading } from "@/components/study/Heading";
import { reportableResult } from "@/views/study/ReportView";
import { CheckLine, InfoIcon } from "lucide-react";
import { AppSurface } from "@shared/components/Surface";

interface SuccessViewProps {
  studyContext: StudyContextData;
  submissionContext: SubmissionContextData;
}

export function SuccessView({ studyContext, submissionContext }: SuccessViewProps) {
  const { study } = studyContext;
  const { resetSubmission, validation } = submissionContext;
  const { setState: setStudyViewState, setView: setStudyView } = useStudyView();

  return (
    <div className="w-full max-w-2xl mt-12">
      <Heading />
      <AppSurface className="mt-8">
        <h2 className="text-lg font-semibold flex items-center gap-x-1.5 mb-4">
          <CheckLine className="stroke-green-600" size={20} strokeWidth={3} />
          <T i18nKey="view.success.title" />
        </h2>
        <p className="text-base">
          <T i18nKey="view.success.instructions1" />
          <br />
          <br />
          <T i18nKey="view.success.instructions2" />
        </p>
        {study && isReportShownLinkedStudy(study) && (
          <div
            className="mt-6 -mb-10 -mx-10 flex gap-x-1.5 px-4 py-3 bg-purple-100/75
                       text-pruple-800 dark:text-purple-200 dark:bg-purple-950/50"
          >
            <div className="flex-none flex items-center h-5">
              <InfoIcon size={16} className="stroke-purple-500" strokeWidth={3} />
            </div>
            <p className="leading-5 text-sm">
              <T i18nKey="view.success.reportInstructions" />
            </p>
          </div>
        )}
      </AppSurface>
      <div className="flex justify-between">
        <div className="mt-6 mb-16">
          <RoundButton
            variant="secondary"
            onClick={() => {
              resetSubmission();
              setStudyViewState((state) => ({
                ...state,
                view: "init",
                instructionsTab: "chatgpt",
              }));
            }}
          >
            Upload more
          </RoundButton>
        </div>
        {study && isReportShownLinkedStudy(study) && reportableResult(validation) && (
          <div className="mt-6 mb-16">
            <RoundButton onClick={() => setStudyView("report")}>View report</RoundButton>
          </div>
        )}
      </div>
    </div>
  );
}
